import { render, staticRenderFns } from "./RemolqueLinea.vue?vue&type=template&id=9a06031a"
import script from "./RemolqueLinea.vue?vue&type=script&lang=js"
export * from "./RemolqueLinea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports